module.exports = __webpack_public_path__ + "img/xiazai.17e9e353.png";